import React, { useEffect, useState } from 'react';
import WidgetModal from './WidgetModal';
import { useSelector } from 'react-redux';
import { WidgetElement } from '../../types/WidgetElement';
import { useWidgetsMutation } from '../../api/widgets';

interface WidgetProps {
    bookId: any;
}
const Widget: React.FC<WidgetProps> = ({ bookId }) => {
    const isopenWidget = useSelector(
        (state: { WidgetOpen: { isOpen: boolean } }) => state.WidgetOpen.isOpen
    );
    const [widget, setWidget] = useState<WidgetElement[]>([]);
    const [
        getWidgets,
        { isLoading: isWidgetsLoading, isError: isWidgetsError },
    ] = useWidgetsMutation();

    useEffect(() => {
        const fetchWidget = async () => {
            getWidgets({ book_id: bookId })
                .unwrap() // This ensures we get the result of the mutation (or an error)
                .then((response: any) => {
                    // Handle successful launch response
                    setWidget(response?.data);
                })
                .catch((error: any) => {
                    // Handle error
                    console.error('Widgets failed:', error);
                });
        };
        fetchWidget();
    }, [bookId]);

    return (
        <div className="z-30">
            {isopenWidget && <WidgetModal items={widget} />}
        </div>
    );
};

export default Widget;
